import React, { useEffect, useState } from "react";
import {
  Modal,
  Text,
  TextInput,
  Button,
  Group,
  Select,
  Divider,
  Badge,
  ActionIcon,
  Stack
} from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { toast } from "react-toastify";

export default function CollaboratorModal({ opened, onClose, formId, formName }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("VIEWER");
  const [collaborators, setCollaborators] = useState([]);
  const [shareError, setShareError] = useState('');

  const token = document.cookie
    .split(";")
    .find(c => c.trim().startsWith("token="))
    ?.split("=")[1];

  const fetchCollaborators = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/forms/${formId}/collaborators`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    const data = await res.json();
    console.log("Collaborators API response:", data);
        if (Array.isArray(data)) {
        setCollaborators(data);
        } else if (Array.isArray(data.collaborators)) {
        setCollaborators(data.collaborators);
        } else {
        setCollaborators([]);
        }
    };

  useEffect(() => {
    if (opened) fetchCollaborators();
  }, [opened]);

  const addCollaborator = async () => {
    if (!email) {
      toast.error("Email is required");
      return;
    }
    setShareError('');
    if (!isAllowedCollaboratorEmail(email)) {
      setShareError(
        "Only @navriti.com or .navriti@gmail.com emails are allowed"
      );
      return;
    }

    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/forms/${formId}/collaborators`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email, role })
      }
    );

    if (res.ok) {
      toast.success("Collaborator added");
      console.log("MAIL PAYLOAD:", { email, role, formName });
      const mailRes = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/forms/${formId}/collaborators/send-mail`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ email, role, formName })
        }
      );

      if (!mailRes.ok) {
        const err = await mailRes.json();
        console.error("MAIL ERROR:", err);
        toast.error("Mail failed");
      }
      setEmail("");
      fetchCollaborators();
    } else {
      const err = await res.json();
      toast.error(err.message || "Failed to add collaborator");
    }
  };

  const removeCollaborator = async (userId) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/forms/${formId}/collaborators/${userId}`,
      {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.ok) {
      toast.success("Collaborator removed");
      fetchCollaborators();
    } else {
      toast.error("Failed to remove collaborator");
    }
  };

  const ALLOWED_EMAIL_DOMAINS = [
    "@navriti.com",
    ".navriti@gmail.com"
  ];

  function isAllowedCollaboratorEmail(email) {
    if (!email) return false;
    return ALLOWED_EMAIL_DOMAINS.some(domain =>
      email.toLowerCase().endsWith(domain)
    );
  }


  return (
    <Modal opened={opened} onClose={onClose} title={<Text fw={600} size="md">Manage collaborators</Text>} 
    centered overlayProps={{
                backgroundOpacity: 0.55,
                blur: 3,
              }}>
      <Stack>
        {/* Add collaborator */}
        <Group>
          <TextInput
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ flex: 1 }}
            error={shareError}
          />
          <Select
            value={role}
            onChange={setRole}
            data={[
              { value: "VIEWER", label: "Viewer" },
              { value: "EDITOR", label: "Editor" }
            ]}
            w={120}
          />
          <Button onClick={addCollaborator}>Add</Button>
        </Group>

        <Divider />

        {/* List collaborators */}
        {Array.isArray(collaborators) && collaborators.length > 0 ? (
        collaborators.map((c) => (
          <Group key={c.user.id} 
          position="apart" p="xs"
          style={{
            borderRadius: 8,
            backgroundColor: "#f8f9fa"
          }}>
            <Text size="sm">{c.user.email}</Text>
            <Group>
              <Badge color={c.role === "EDITOR" ? "#4f85f1ff" : "#4db0e5ff"}>
                {c.role}
              </Badge>
              {c.role !== "OWNER" && (
                <ActionIcon
                    color="red"
                    onClick={() => removeCollaborator(c.user.id)}
                    variant="subtle"
                    title="Remove collaborator"
                >
                    <IconTrash size={16} />
                </ActionIcon>
                )}
            </Group>
          </Group>
        ))
        ) : (
        <Text size="sm" c="dimmed" align="center">
            No collaborators added yet
        </Text>
        )}
      </Stack>
    </Modal>
  );
}
